export default {"src":"/_next/static/media/linkedin-icon.abe22820.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};